var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560 560",
    xmlns: "http://www.w3.org/2000/svg",
    strokeMiterlimit: 1.414,
    strokeLinejoin: "round",
    id: "plex-icon-search-560",
    "aria-hidden": "true",
    className: "PlexIcon-plexIcon-8Tamaj QuickSearchInput-searchIcon-38PAh5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.883,407.883C315.613,433.168 271.525,448 224,448C100.371,448 0,347.629 0,224C0,100.371 100.371,0 224,0C347.629,0 448,100.371 448,224C448,271.525 433.168,315.613 407.883,351.883L560,504L504,560L351.883,407.883ZM56,224C56,316.722 131.278,392 224,392C316.722,392 392,316.722 392,224C392,131.278 316.722,56 224,56C131.278,56 56,131.278 56,224Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.68cc60ba.svg";
export { ForwardRef as ReactComponent };